import React from 'react';

import { Spacing, SpacingProps } from '../../Spacing';

export const Field: React.FC<Omit<SpacingProps, 'ref'>> = ({
  className,
  ...props
}) => <Spacing gap={2} stack className={className} {...props} />;
